import React, { useState, useEffect, useCallback } from "react";
import "./Gallery.css";

const TOTAL_IMAGES = 116;
const PAGE_SIZE = 24;

const allImages = Array.from(
  { length: TOTAL_IMAGES },
  (_, i) => `/sbs_products_${i + 1}.jpg`
);

const Gallery = () => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const visibleImages = allImages.slice(0, visibleCount);
  const hasMore = visibleCount < allImages.length;

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);

  const showPrev = useCallback(
    () =>
      setLightboxIndex((i) =>
        i === null ? i : (i - 1 + allImages.length) % allImages.length
      ),
    []
  );

  const showNext = useCallback(
    () =>
      setLightboxIndex((i) =>
        i === null ? i : (i + 1) % allImages.length
      ),
    []
  );

  useEffect(() => {
    if (lightboxIndex === null) return;

    const handleKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKey);
    };
  }, [lightboxIndex, closeLightbox, showPrev, showNext]);

  return (
    <section className="gallery-page">
      <div className="container">
        <div className="gallery-header">
          <h1 className="myanmar-text-bold gallery-title">ဓာတ်ပုံပြခန်း</h1>
          <p className="english-text gallery-subtitle">Product Gallery</p>
        </div>

        <div className="gallery-grid">
          {visibleImages.map((img, idx) => (
            <button
              type="button"
              className="gallery-item"
              key={img}
              onClick={() => openLightbox(idx)}
            >
              <img
                src={img}
                alt={`Product ${idx + 1}`}
                loading="lazy"
                className="gallery-thumb"
              />
            </button>
          ))}
        </div>

        {hasMore && (
          <div className="gallery-load-more">
            <button
              type="button"
              className="load-more-btn myanmar-text"
              onClick={() =>
                setVisibleCount((c) => Math.min(c + PAGE_SIZE, allImages.length))
              }
            >
              နောက်ထပ်ကြည့်ရန်
            </button>
          </div>
        )}
      </div>

      {lightboxIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <button
            type="button"
            className="lightbox-close"
            onClick={closeLightbox}
            aria-label="Close"
          >
            ×
          </button>
          <button
            type="button"
            className="lightbox-nav lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              showPrev();
            }}
            aria-label="Previous"
          >
            ‹
          </button>
          <img
            src={allImages[lightboxIndex]}
            alt={`Product ${lightboxIndex + 1}`}
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            type="button"
            className="lightbox-nav lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              showNext();
            }}
            aria-label="Next"
          >
            ›
          </button>
          <div className="lightbox-counter">
            {lightboxIndex + 1} / {allImages.length}
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
